export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/pen_ink.bd450fb.png";